<app-lfsa-card-v2 [innTemplate]="enviarTemplate" [innTemplateButton]="innTemplateButton" [titulo]="'Producto Especificación Registrados'" [modulo]="'IO-Industrias'" [tituloCard]="'Producto Especificación'" *ngIf="!mostrarFormulario && !mostrarFormularioRasp">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
  <div class="col-md-6">
    <div class="pagetitle">
      <div class="btn-group-justified btn-group" style="float: right;">
        <a (click)="procesar()" class="btn btn-outline-success">
          <span class="fa fa-plus"></span>
          NUEVO
        </a>

      </div>
    </div>
  </div>
</ng-template>
<ng-template #enviarTemplate>
  <div class="row col-md-12 animated fadeInRight">
    <!--<h2 class="container float-left"> Buscar </h2>-->

    <div class="container">
      <form [formGroup]="formulario" novalidate class="form-group">
        <div class = "row">
          <div class="form-group col-12 col-md-6">
            <app-lfsa-combo-box (change)="getLineaPlanta()" [mostrarImg]="false" [rutaImagen]="''"
              [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="cmbPlanta" formControlName="planta"
              [control]="formulario.get('planta')" [label]="'Planta'" [id]="'planta'">
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-12 col-md-6">
            <app-lfsa-combo-box [mostrarImg]="false" [rutaImagen]="''" (change)="selecionLinea()"
              [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="cmbLinea" formControlName="linea"
              [control]="formulario.get('linea')" [label]="'Línea'" [id]="'linea'">
            </app-lfsa-combo-box>
          </div>
        </div>
      </form>
      <hr />
      <div class="row">
        <div class="form-group col-md-12">
          &nbsp;
          <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
            (keyup)="onQuickFilterChanged() " #quickFilter />
        </div>

      </div>
      <br>
      <div class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <div *ngIf="!loading">
            <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
              No existen productos registrados para esta linea.
            </div>
            <ag-grid-angular *ngIf="!listaVacia"
              #agGrid class="{{tvcModulo.agGrid.class}}"
              [ngStyle]="tvcModulo.agGrid.style" id="{{tvcModulo.agGrid.id}}"
              [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs" [rowSelection]="rowSelection"
              [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
              [paginationPageSize]="tvcModulo.agGrid.paginacion">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>



<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Selecione la Linea a asignar'" [idButton]="'abrirModal'"
  [idOpen]="'Modal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <form [formGroup]="formularioCustom" novalidate class="form-group">
    <div class="row">

      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('idMaterial') | formControl"
                            [id]="'idMaterial'"
                            (keyup)="limpiarDes() "
                            [label]="'ID Material*'" [mostrarImg]="false" [placeholder]="'Id Material'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="idMaterial">
        </app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-2">
        <label>&nbsp;</label>
        <button (click)="buscar()" [tooltip]="'Buscar Material'" *ngIf="bandNew"
          class="btn btn-success btn-block"><i class="fa fa-search" aria-hidden="true"></i></button>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [control]="formularioCustom.get('descMaterial') | formControl"
                            [id]="'descMaterial'"
                            [label]="'Nombre Material'" [isReadOnly]="true"  [mostrarImg]="false" [placeholder]="'Nombre Material'"
                            [rutaImagen]=""
                            [type]="'text'"
                            formControlName="descMaterial">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('perGeneral') | formControl"
                            [id]="'perGeneral'"
                            [label]="'Porcentaje Tolerancia Genral*'" [mostrarImg]="false" [placeholder]="'2'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="perGeneral">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('perMax') | formControl"
                            [id]="'perMax'"
                            [label]="'Porcentaje Tolerancia Máximo*'" [mostrarImg]="false" [placeholder]="'2'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="perMax">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('perMin') | formControl"
                            [id]="'perMin'"
                            [label]="'Porcentaje Tolerancia Mínimo*'" [mostrarImg]="false" [placeholder]="'2'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="perMin">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('peso') | formControl"
                            [id]="'peso'"
                            [label]="'Peso*'" [mostrarImg]="false" [placeholder]="'0.0'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="peso">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('pesoEmbalaje') | formControl"
                            [id]="'pesoEmbalaje'"
                            [label]="'Peso Embalaje*'" [mostrarImg]="false" [placeholder]="'10'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="pesoEmbalaje">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('alturaCaja') | formControl"
                            [id]="'alturaCaja'"
                            [label]="'Altura Caja*'" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="alturaCaja">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('retardoRechazo') | formControl"
                            [id]="'retardoRechazo'"
                            [label]="'Retardo de Rechazo*'" [mostrarImg]="false" [placeholder]="'10'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="retardoRechazo">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('confNsensor') | formControl"
                            [id]="'confNsensor'"
                            [label]="'CONF N SENSOR*'" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="confNsensor">
        </app-lfsa-input>
      </div>
      <div class="form-group col-1 col-md-1">
        <label>&nbsp;</label><br>

      </div>
      <div class="form-group col-2 col-md-3">
        <label>&nbsp;</label><br>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="habCodEan14" (change)="changeValue()" formControlName="habCodEan14">
          <label class="form-check-label" for="flexSwitchCheckDefault">Hab. Código EAN14</label>
        </div>
      </div>
      <div class="form-group col-2 col-md-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="habCodEan128" formControlName="habCodEan128">
          <label class="form-check-label" for="habCodEan128">Hab. Código EAN128</label>
        </div>
      </div>
      <div class="form-group col-2 col-md-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="habMenor" formControlName="habMenor">
          <label class="form-check-label" for="habMenor">Hab. Peso Menor</label>
        </div>
      </div>
      <div class="form-group col-2 col-md-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="habMayor" formControlName="habMayor">
          <label class="form-check-label" for="habMayor">Hab. Peso Mayor</label>
        </div>
      </div>
      <div class="form-group col-2 col-md-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="habAlt" formControlName="habAlt">
          <label class="form-check-label" for="habAlt">Hab. AltCaja</label>
        </div>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioCustom.invalid" (click)="guardar()">Enviar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
